import React from 'react';

import { Container, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { FeaturedPartnerCard } from './FeaturedPartnerCard';

const useStyles = makeStyles((theme) => ({
  partnerContainer: {
    marginTop: '4rem',
  },
	sectionHeader: {
		color: theme.workwaveBlue,
		fontWeight: 'bold',
		textTransform: 'uppercase',
	},
	// [theme.breakpoints.down('xl')]: {
	// 	filterContainer: {
	// 		'& > div:nth-child(3n)': {
	// 			marginRight: '0px',
	// 		},
	// 	},
	// },
  filterContainer: {
    '& > div': {
      marginLeft: '12.5px',
      marginRight: '12.5px',
    },
  },
	// [theme.breakpoints.down('sm')]: {
	// 	filterContainer: {
	// 		'& > div:nth-child(3n)': {
	// 			marginLeft: '12.5px',
  //       marginRight: '12.5px',
	// 		},
	// 		'& > div:nth-child(2n)': {
	// 			marginLeft: '0px',
  //       marginRight: '0px',
	// 		},
	// 	},
	// },
	// [theme.breakpoints.down('xs')]: {
	// 	filterContainer: {
	// 		'& > div:nth-child(3n)': {
  //       marginLeft: '0px',
	// 			marginRight: '0px',
	// 		},
	// 		'& > div:nth-child(2n)': {
  //       marginLeft: '0px',
	// 			marginRight: '0px',
	// 		},
	// 	},
	// },
}));

export const FeaturedPartners = ({ featuredPartnersHeader, featuredPartnerCards, featuredPartnerRef }) => {
	const classes = useStyles();
	const med = useMediaQuery('(max-width: 960px)');
	return (
		<Container
			className={classes.partnerContainer}
			ref={featuredPartnerRef}>
			<Grid container justifyContent='center'>
				<Typography
					variant='h2'
					color='primary'
					style={{ paddingBottom: '4rem', textAlign: 'center' }}>
					{featuredPartnersHeader}
				</Typography>
			</Grid>
			<Grid
				container
				direction='row'
				justifyContent='center'
				alignItems='center'
				spacing={3}>
				<Grid
					item
					container
					direction='row'
					justifyContent='center'
					className={classes.filterContainer}>
					{featuredPartnerCards.map((partner, index) => ( 
            <FeaturedPartnerCard
              key={index}
              name={partner.featuredPartnerTitle}
              body={partner.featuredPartnerBody}
              slug={partner.featuredPartnerLink}
              logo={partner.featuredPartnerLogo}
              // promo={partner.promo}
              // affiliateLink={partner.affiliateLink}
            />
					))}
				</Grid>
			</Grid>
		</Container>
	);
};
